import { useTranslation } from 'react-i18next';
import { sanitizeAboutHtml } from 'frontend/features/branding/footer/sanitizeHtml';
import Modal from '../ui/Modal';

const hasVisibleContent = (html) => {
  if (!html || typeof DOMParser === 'undefined') {
    return false;
  }

  const document = new DOMParser().parseFromString(html, 'text/html');
  return Boolean(document.body.textContent?.trim());
};

const AboutUsModal = ({ open, onClose, aboutUsText }) => {
  const { t } = useTranslation(['layout']);
  const sanitizedAboutUs = sanitizeAboutHtml(aboutUsText ?? '');
  const hasContent = hasVisibleContent(sanitizedAboutUs);

  return (
    <Modal open={open} onClose={onClose} title={t('footer.about_us')} maxWidth='lg'>
      <div className='modal-body'>
        {hasContent ? (
          <div
            className='text-sm text-justify mb-8'
            dangerouslySetInnerHTML={{ __html: sanitizedAboutUs }}
          />
        ) : (
          <p className='text-sm text-justify mb-8'>
            {t('footer.about_us_empty')}
          </p>
        )}
      </div>
      <Modal.Actions>
        <button
          onClick={onClose}
          className='px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors'
          type='button'
        >
          {t('footer.close')}
        </button>
      </Modal.Actions>
    </Modal>
  );
};

export default AboutUsModal;
